import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-restricted-paths
import { prepareUser } from '../../../node/mappers/prepareUser';
import { resolveUser } from '../../../shared/services/user';
import { setUser } from '../../../shared/slices/userReduces';
import { IThunkApi } from '../../../shared/types/redux';
import { TUser } from '../../../shared/types/user';

export const getUserAction = createAsyncThunk<TUser, void, IThunkApi>('user/getUserAction', async (_, thunkApi) => {
  const {
    dispatch,
    getState,
    extra: { httpApi, logger, config },
  } = thunkApi;
  const state = getState();

  const user = await resolveUser({ config, httpApi, logger, subdomain: state.subdomain });
  const mappedUser = prepareUser(user);
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  dispatch(setUser(mappedUser) as any);

  return mappedUser;
});
